import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { MyDateField } from "../MyDateField";
import { MyDateTimeInput } from "../MyDateTimeInput";
import { Datagrid, Edit, Toolbar, SaveButton, EditButton, Filter, List, NumberInput, SelectInput, SimpleForm, TextField, TextInput, required, useDataProvider, useNotify } from "react-admin";
import moment from "moment-timezone";

const TrafficLogTitle = ({ record }) => {
  return <span>Traffic Log - {record ? `${record.log_title}` : ""}</span>;
};

const NetworkCodeSelectInput = (props) => {
  const dataProvider = useDataProvider();
  const [networkCodes, setNetworkCodes] = useState([]);

  useEffect(() => {
    dataProvider
      .fetchTrafficLogNetworkCode()
      .then(({ data }) => {
        const arr = data.map((networkCode) => ({ id: networkCode, name: networkCode }));
        setNetworkCodes(arr); // Set the fetched options
      })
      .catch((error) => {
        console.error("Error fetching network code:", error);
      });
  }, []);

  return <SelectInput {...props} choices={networkCodes} label="network code" source="network_code" alwaysOn />;
};

const TrafficLogFilter = (props) => (
  <Filter {...props}>
    <NetworkCodeSelectInput alwaysOn />
    <TextInput label="on_air_date" source="on_air_date" alwaysOn disabled />
    <TextInput label="programme_no" source="programme_no" alwaysOn />
  </Filter>
);

export const TrafficLogList = (props) => {
  const todayInHongKong = moment().tz("Asia/Hong_Kong").format("YYYY-MM-DD");
  return (
    <List
      {...props}
      sort={{ field: "event_start_datetime", order: "ASC" }}
      filters={<TrafficLogFilter />}
      filterDefaultValues={{
        // on_air_date: "2025-01-14",
        on_air_date: todayInHongKong,
      }}
      pagination={false}
      exporter={false}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField source="network_code" />
        <MyDateField label="event_start_datetime" source="event_start_datetime" showTime />
        <TextField source="dfn" />
        <TextField source="seg_no" />
        <TextField source="log_title" />
        <TextField source="programme_no" />
        <TextField source="episode_no" />
        <EditButton />
      </Datagrid>
    </List>
  );
};

const TrafficLogEditToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
};

export const TrafficLogEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic" title={<TrafficLogTitle />} actions={false}>
      <SimpleForm toolbar={<TrafficLogEditToolbar />}>
        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <TextInput label="network code" source="network_code" fullWidth disabled />
          </Grid>
          <Grid item sm={12} md={6}>
            {/* <TextInput label="event_start_datetime" source="event_start_datetime" fullWidth disabled /> */}
            <MyDateTimeInput label="event_start_datetime" source="event_start_datetime" fullWidth disabled />
          </Grid>
        </Grid>
        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <TextInput label="dfn" source="dfn" validate={required()} fullWidth />
          </Grid>
          <Grid item sm={12} md={6}>
            <NumberInput label="seg_no" source="seg_no" validate={required()} fullWidth />
          </Grid>
        </Grid>
        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <TextInput label="log_title" source="log_title" fullWidth disabled />
          </Grid>
          <Grid item sm={12} md={6}>
            <NumberInput label="programme_no" source="programme_no" fullWidth disabled />
          </Grid>
        </Grid>
        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <NumberInput label="episode_no" source="episode_no" fullWidth disabled />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
